// Mappe l'etat GET /api/auth/me sur AccessGate (confort d'affichage, JAMAIS une garde).
//
// CE VERDICT N'EST PAS UNE AUTORISATION. L'autorite reste le serveur, sans
// exception : chaque route metier d'admin porte requireAdmin (requireAuth +
// requireRole bc_key ADM, minRole ADMIN, bypass corporate). Si tu te surprends a
// proteger quelque chose ICI, la protection manque cote serveur.
import { classifyMeAccessError } from '@gs/api-client';
import type { AccessGateKind } from '@gs/ui';
import type { AdminMe, SystemCRole } from '../hooks/useMe';

/**
 * Code de non-provisionnement tel qu'il arrive AUJOURD'HUI : admin ne remappe pas
 * l'AuthError partagee (401 USER_NOT_PROVISIONED ; apiFetch rejoue une fois puis
 * leve ApiUnauthorizedError avec le corps d'origine — pas de boucle).
 */
export const USER_NOT_PROVISIONED = 'USER_NOT_PROVISIONED';

/**
 * Code attendu quand admin remappera en 403 propre, sur le patron du parc
 * (HUB_/INV_/GEST_/UG_ + USER_NOT_PROVISIONED). Le remap est au lot
 * feat-acces-zero-la-porte-provisionne ; accepte des maintenant pour que sa
 * bascule ne transforme pas un refus en « acces non verifiable ».
 */
export const ADMIN_USER_NOT_PROVISIONED = 'ADMIN_USER_NOT_PROVISIONED';

export interface AdminMeSlice {
  isError: boolean;
  error: unknown;
  data?: AdminMe | undefined;
}

/** Role Systeme C d'admin tel que le serveur le rend (null = aucun role ADM). */
export function adminRoleOf(me: AdminMe | undefined): SystemCRole | null {
  return me?.appRoles.find((r) => r.appKey === 'admin')?.role ?? null;
}

/**
 * null = acces OK.
 *
 * - erreur non-provisionnement (l'un des deux codes) -> notProvisioned.
 * - toute autre erreur /api/auth/me -> unverifiable (classifyMeAccessError, socle) :
 *   jamais la coquille pleine sur un profil qu'on n'a pas pu lire.
 * - role ADM different d'ADMIN -> noRole : miroir EXACT de requireAdmin (minRole
 *   ADMIN ; le bypass corporate est deja rendu 'ADMIN' par resolveDisplayRole).
 * - moduleNotEntitled n'est PAS emis : admin n'est pas un module CompanyModules.
 */
export function resolveAccessGate(me: AdminMeSlice): AccessGateKind | null {
  if (me.isError) {
    if (classifyMeAccessError(me.error, ADMIN_USER_NOT_PROVISIONED) === 'notProvisioned') {
      return 'notProvisioned';
    }
    return classifyMeAccessError(me.error, USER_NOT_PROVISIONED);
  }
  if (!me.data) return null;
  if (adminRoleOf(me.data) !== 'ADMIN') return 'noRole';
  return null;
}
